import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ecommerceService } from "../../services/ecommerce.service";
import "./caringCommunity.scss";

export function ItemCaring(props) {
  const [CommunitiesData, setCommunitiesData] = useState([]);

  useEffect(() => {
    getCommunities();
  }, []);

  async function getCommunities() {
    // useCaringCommunity
    //   .getCommunitiesClient(process.env.REACT_APP_COMPANY)
    //   .then((result) => {
    //     setCommunitiesData(result);
    //   });

    ecommerceService.getProviders(14).then((result) => {
      setCommunitiesData(result);
    });
  }

  return (
    <div className="cards-caring">
        {CommunitiesData.map((community) => (
            <div className="card-caring">
                <div className="card-caring-content">
                  <a href={community.urlSite} target="_blank" rel="noopener noreferrer">
                    <h5>{community.name}</h5>
                  </a>
                  <div className="card-caring-content-info">
                    <Link to={"/caring-community/" + community.id}>
                      <div className="container-img">
                        <img src={community.providerLogo} alt={community.name} />
                      </div>
                    </Link>
                    <Link to={"/caring-community/" + community.id} className="text-description">
                      {community.info}{" "}
                    </Link>
                  </div>
                </div>
            </div>
        ))}
    </div>
  );
}
